import { UserData } from 'client/reducers/userReducer'
import { Dispatch } from 'redux'
import * as auth from 'client/api/authentication'
import { ApiResult, klubbleAPI } from 'client/api/common'
import { Role } from 'client/enums/Role'
import * as Sentry from '@sentry/browser'
import { SettingsAction, UserAction } from './types'
import * as settingActions from './settingActions'

export const SET_USER = 'SET_USER'
export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_FIRST_NAME = 'SET_FIRST_NAME'
export const CLEAR_USER = 'CLEAR_USER'
export const SET_OPT_IN_STATUSSES = 'SET_OPT_IN_STATUSSES'
export const SET_ROLES = 'SET_ROLES'

export const setUser = (user?: UserData) => async (dispatch: Dispatch<UserAction | SettingsAction>) => {
  let userData

  // if a userData is supplied then use that to set the user, otherwise first fetch the userData
  if (user) {
    userData = user
  } else {
    try {
      const { data } = await klubbleAPI.get<UserData>('Auth/getuser')
      userData = data
    } catch (e) {
      Sentry.captureMessage('log out after error getUser', { extra: { statusCode: e.response?.status } })
      auth.logoutAndLogin()
    }
  }

  if (!userData) return

  dispatch({
    type: SET_USER,
    payload: userData,
  })
  const settings = JSON.parse(userData.settingsJson) || {
    showTimer: true,
    skipCompletedLetters: true,
    skipCelebration: true,
  }
  dispatch({
    type: settingActions.SET_SETTINGS,
    payload: settings,
  })
}

export const setOptInStatusses = (subscribeNewsletter: boolean, subscribeWeeklyStatistics: boolean, acceptTerms: string) => async (dispatch: Dispatch<UserAction>) => {
  klubbleAPI.post('Auth/setOptInStatusses', JSON.stringify({ subscribeNewsletter, subscribeWeeklyStatistics, acceptTerms }), {
    headers: {
      'Content-Type': 'application/json',
    },
  })

  dispatch({
    type: SET_OPT_IN_STATUSSES,
    payload: { subscribeNewsletter, subscribeWeeklyStatistics },
  })
}

export const setUserName = (name: string) => async (dispatch: Dispatch<UserAction>) => {
  dispatch({
    type: SET_USER_NAME,
    payload: name,
  })
}

export const saveFirstName = (firstName: string) => async (dispatch: Dispatch<UserAction>) => {
  const { data: response } = await klubbleAPI.post<ApiResult<boolean>>('Auth/savefirstname', {
    firstName,
  })
  if (response.data) {
    dispatch({
      type: SET_FIRST_NAME,
      payload: firstName,
    })
  }
}

export const clearUser = () => async (dispatch: Dispatch<UserAction>) => {
  dispatch({
    type: CLEAR_USER,
  })
}

export const setRoles = (payload: Role[]) => async (dispatch: Dispatch<UserAction>) => {
  dispatch({
    type: SET_ROLES,
    payload,
  })
}

export const clearRoles = () => async (dispatch: Dispatch<UserAction>) => {
  dispatch({
    type: SET_ROLES,
    payload: [],
  })
}
